import styled from "@emotion/styled";
import { Switch } from "@kaltura/ds-react-components";
import { Container } from "../../controlled-form/CommonStyles";
import { FormLabel } from "../form-label/FormLabel";

export interface InlineToggleFieldProps {
    className?: string;
    id: string;
    checked: boolean;
    disabled?: boolean;
    label: string;
    onChange: (checked: boolean) => void;
}

const InlineContainer = styled(Container)(({ theme }) => ({
    marginTop: 0,
    flexDirection: "row",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "flex", // override original
    },
}));

const StyledFormInlineLabel = styled(FormLabel)(({ theme }) => ({
    height: theme.spacing(2),
    position: "relative",
    bottom: 1,
}));

/**
 * inline toggle
 */
export const InlineToggleField = (props: InlineToggleFieldProps) => {
    const { className, id, checked, disabled = false, label, onChange } = props;

    return (
        <Container className={className}>
            <InlineContainer>
                <Switch
                    id={id}
                    onChange={(event, checked) => {
                        onChange(checked);
                    }}
                    checked={checked}
                    disabled={disabled}
                    size={"small"}
                    slotProps={{ input: { "aria-describedby": `${id}-description` } }}
                />
                <StyledFormInlineLabel fontWeightBold={true} id={`${id}-description`} htmlFor={id} text={label} />
            </InlineContainer>
        </Container>
    );
};
export default InlineToggleField;
